import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { replace } from 'react-router-redux';
import {
  Button,
  Container,
  Menu,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import { flashSuccessMessage, flashErrorMessage } from '../../actions/flash';
import { fetchAddressSettings } from '../../actions/addressSettings';
import { fetchCustomOptions } from '../../actions/customOptions';
import config from '../../../config';
import NavBar from '../../components/NavBar';
import Form from './Form';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';

class New extends Component {
  static propTypes = {
    token: PropTypes.string,
    location: PropTypes.shape({
      hash: PropTypes.string,
    }),
    loading: PropTypes.bool,
    auth: PropTypes.shape({
      companyBranch: PropTypes.shape({
        id: PropTypes.number,
      }),
      isHeadquarters: PropTypes.bool,
    }),
    addressSettings: PropTypes.shape({
      data: PropTypes.array,
    }),
    customOptions: PropTypes.shape({
      data: PropTypes.array,
    }),
    onCheck: PropTypes.func,
    t: PropTypes.func,
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  static mapStateToProps = state => ({
    auth: state.auth,
    addressSettings: state.addressSettings,
    customOptions: state.customOptions,
  })

  constructor(props) {
    super(props);
    this.state = {
      hasChanges: false,
    };
  }
  componentWillMount() {
    const { store } = this.context;
    store.dispatch(fetchAddressSettings());
    store.dispatch(fetchCustomOptions());
  }
  async submit(validations, customer) {
    const { store } = this.context;
    const { t } = this.props;
    const errors = validations.filter(v => !v.isValid);
    if (errors.length > 0) {
      store.dispatch(flashErrorMessage({ header: t('Please fix form errors', { ns: TRANSLATION_FILES.translation }), list: errors.map(l => l.message) }));
      return;
    }
    let res;
    try {
      res = await this.form.submit(`${config.get('bookApiURL')}/customers/`, {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
        body: JSON.stringify(customer),
      });
    } catch (err) {
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage(err));
      return;
    }
    this.setState({ hasChanges: false }, () => {
      this.handleOnCheck(false, (noChanges) => {
        if (noChanges) {
          store.dispatch(replace(`/customers/${res.id}/`));
          store.dispatch(flashSuccessMessage({ header: t('Create Success', { ns: TRANSLATION_FILES.translation }), message: t('{{name}} successfully created', { ns: TRANSLATION_FILES.translation, name: customer.customerDetail.name }) }));
        }
      });
    });
  }
  handleSubmit = (event) => {
    event.preventDefault();
    const { store } = this.context;
    this.form.handleSubmit(event)
      .catch((err) => {
        Bugsnag.notifyException(err);
        store.dispatch(flashErrorMessage(err));
      });
  }
  handleOnChange = (hasChanges) => {
    if (hasChanges !== this.state.hasChanges) {
      this.setState({ hasChanges }, () => {
        this.handleOnCheck(hasChanges);
      });
    }
  }
  handleOnCheck = (hasChanges = false, callback) => {
    if (this.props.onCheck) {
      this.props.onCheck(hasChanges, callback);
    }
  }
  render() {
    const { t } = this.props;
    return (
      <Container>
        <NavBar
          header={t('New', { ns: TRANSLATION_FILES.screens })}
          rightNav={
            <Menu.Item fitted>
              <Button
                positive
                content={t('Create', { ns: TRANSLATION_FILES.screens })}
                onClick={this.handleSubmit}
              />
            </Menu.Item>
          }
        />
        <Form
          ref={(ref) => { this.form = ref; }}
          onSubmit={(validations, customer) => {
            this.submit(validations, customer);
          }}
          onChange={this.handleOnChange}
          location={this.props.location}
          auth={this.props.auth}
          addressSettings={this.props.addressSettings}
          customOptions={this.props.customOptions}
          loading={this.props.loading}
        />
      </Container>
    );
  }
}

export default withTranslation(namespaces)(connect(New.mapStateToProps)(New));



// WEBPACK FOOTER //
// ./src/containers/Customers/New.jsx